<template>
  <div class="iconn_svg" ref="iconContainer"></div>
</template>

<script>

const iconsNeedFill = [
  'icon_serviceprovider',
  'icon_vendor',
  'icon_arrow_down',
  'icon_arrow_up2',
  'icon_cup',
  'icon_file',
  'icon_location',
  'icon_live',
  'icon_arrow_right',
  'icon_arrow_left',
  'icon_circle',
  'icon_sort_down',
  'icon_sort_up',
  'icon_drag',
  'logo',
  'icon_arrow_sort_up',
  'icon_arrow_sort_down',
  'icon_banner',
  'icon_group',
  'icon_logo',
  'icon_message',
  'icon_pointer',
  'icon_download',
  'icon_calendar',
  'icon_purple_full_logo',
  'icon_link',
];

const iconsFillOnly = [
  'icon_thumb_down',
  'icon_save',
  'icon_handshake',
  'icon_folder',
  'icon_location',
  'icon_message',
  'icon_delete',
  'icon_chat',
  'icon_logout',
  'icon_video',
  'icon_funds',
  'icon_list',
  'icon_map',
  'icon_warning_grey',
  'icon_roadshows',
  'icon_car',
  'icon_taxi',
  'icon_restaurant',
  'icon_train',
  'icon_building',
  'icon_lock',
  'icon_users',
  'icon_plus',
  'icon_description',
  'icon_check_circle',
  'icon_out',
  'icon_user_add',
  'icon_ai',
  'icon_event_busy',
  'icon_more_time',
  'icon_visibility',
  'icon_visibility_off',
  'icon_people',
  'icon_warning_2',
  'icon_inbox',
  'icon_linkedin',
];

export default {
  name: 'SvgFactory',
  props: {
    name: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
    },
    customColor: {
      type: String,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      svgElement: null,
    };
  },
  watch: {
    name() {
      this.setupSvg();
    },
    customColor() {
      if (iconsFillOnly.includes(this.name)) {
        this.svgElement.style.fill = this.customColor;
      } else {
        this.svgElement.style.stroke = this.customColor;
        if (iconsNeedFill.includes(this.name)) {
          this.svgElement.style.fill = this.customColor;
        }
      }

      for (let i = 0; i < this.svgElement.children.length; i += 1) {
        if (iconsFillOnly.includes(this.name)) {
          this.svgElement.children[i].style.fill = this.customColor;
        } else {
          this.svgElement.children[i].style.stroke = this.customColor;
          if (iconsNeedFill.includes(this.name)) {
            this.svgElement.children[i].style.fill = this.customColor;
          }
        }
      }
    },
  },
  methods: {
    setupSvg() {
      if (this.name) {
        const svgDiv = document.createElement('svg');

        // Dynamically importing the svg!
        /* eslint-disable-next-line */
        svgDiv.innerHTML = require(`!html-loader!../../../../../_common/svg/${this.name}.svg`).default;
        this.svgElement = svgDiv.firstChild;
        this.$refs.iconContainer.innerHTML = '';
      }

      // Resize the icon
      let aspectRatio = 1;
      if (this.svgElement && this.width) {
        const viewBox = this.svgElement.getAttribute('viewBox').split(' ').map((n) => Number(n));

        if (this.isHorizontal) {
          aspectRatio = (viewBox[3] / viewBox[2]).toFixed(2);
        } else {
          aspectRatio = (viewBox[2] / viewBox[3]).toFixed(2);
        }

        this.svgElement.setAttribute('width', this.width);
        this.svgElement.setAttribute('height', aspectRatio * this.width);
      }

      // Add the color classes
      switch (this.color) {
        // Basic
        case 'primary':
          this.svgElement.classList.add('iconn_svg--primary');
          break;
        case 'secondary':
          this.svgElement.classList.add('iconn_svg--secondary_gray-fill');
          break;
        case 'success-filled':
          this.svgElement.classList.add('iconn_svg--white-fill');
          break;
        case 'success-outline':
          this.svgElement.classList.add('iconn_svg--green_800-fill');
          break;
        case 'warning-outline':
          this.svgElement.classList.add('iconn_svg--warning-fill');
          break;
        case 'info-outline':
          this.svgElement.classList.add('iconn_svg--blue_500-fill');
          break;
        case 'error-outline':
          this.svgElement.classList.add('iconn_svg--red_500-fill');
          break;
        case 'text':
          this.svgElement.classList.add('iconn_svg--blue_500-fill');
          break;
        case 'secondary-blue':
          this.svgElement.classList.add('iconn_svg--secondary_blue');
          break;
        case 'secondary-gray':
          this.svgElement.classList.add('iconn_svg--secondary_gray');
          break;

          // By Company Type
        case 'allocator':
          this.svgElement.classList.add('iconn_svg--allocator');
          break;
        case 'manager':
          this.svgElement.classList.add('iconn_svg--manager');
          break;
        case 'serviceprovider':
          this.svgElement.classList.add('iconn_svg--serviceprovider');
          break;
        case 'media':
          this.svgElement.classList.add('iconn_svg--media');
          break;
        case 'guest':
          this.svgElement.classList.add('iconn_svg--guest');
          break;
        case 'speaker':
          this.svgElement.classList.add('iconn_svg--speaker');
          break;
        case 'sponsor':
          this.svgElement.classList.add('iconn_svg--sponsor');
          break;
        case 'iconnections':
          this.svgElement.classList.add('iconn_svg--iconnections');
          break;
        case 'vendor':
          this.svgElement.classList.add('iconn_svg--vendor');
          break;
        case 'staff':
          this.svgElement.classList.add('iconn_svg--staff');
          break;

          // Typography
        case 'typography-black':
          this.svgElement.classList.add('iconn_svg--typography_black');
          break;
        case 'typography-gray':
          this.svgElement.classList.add('iconn_svg--typography_gray');
          break;

          // Other
        case 'black':
          this.svgElement.classList.add('iconn_svg--black');
          break;
        case 'white':
          this.svgElement.classList.add('iconn_svg--white');
          break;
        case 'gray-800':
          this.svgElement.classList.add('iconn_svg--gray_800');
          break;
        case 'gray-100':
          this.svgElement.classList.add('iconn_svg--gray_100');
          break;
        case 'blue-500':
          this.svgElement.classList.add('iconn_svg--blue_500');
          break;

          // New / not defined
        case 'dark-yellow':
          this.svgElement.classList.add('iconn_svg--dark_yellow');
          break;

        default:
          break;
      }

      // Some icons need to be filled with the selected color as well....
      if (iconsNeedFill.includes(this.name)) {
        this.svgElement.classList = `${this.svgElement.classList.value}  ${this.svgElement.classList.value}-fill`;
      }

      // Add custom colors (usually from the backend)
      if (this.customColor) {
        if (iconsFillOnly.includes(this.name)) {
          this.svgElement.style.fill = this.customColor;
        } else {
          this.svgElement.style.stroke = this.customColor;
          if (iconsNeedFill.includes(this.name)) {
            this.svgElement.style.fill = this.customColor;
          }
        }

        for (let i = 0; i < this.svgElement.children.length; i += 1) {
          if (iconsFillOnly.includes(this.name)) {
            this.svgElement.children[i].style.fill = this.customColor;
          } else {
            this.svgElement.children[i].style.stroke = this.customColor;
            if (iconsNeedFill.includes(this.name)) {
              this.svgElement.children[i].style.fill = this.customColor;
            }
          }
        }
      }

      // Finally append the element!
      if (this.svgElement) {
        this.$refs.iconContainer.appendChild(this.svgElement);

        // Set the parent div to fit the icon
        this.$refs.iconContainer.style.width = `${this.width}px`;
        this.$refs.iconContainer.style.height = `${aspectRatio * this.width}px`;
      }
    },
  },
  mounted() {
    this.setupSvg();
  },
};
</script>

<style lang="scss">
@import "@foundation";

.iconn_svg {
  &--primary {
    * {
      stroke: map-get($primary, 'purple-500');
    }

    &-fill {
      * {
        fill: map-get($primary, 'purple-500');
      }
    }
  }

  &--secondary_blue {
    * {
      stroke: map-get($secondary, 'blue-500');
    }

    &-fill {
      * {
        fill: map-get($secondary, 'blue-500');
      }
    }
  }

  &--secondary_gray {
    * {
      stroke: map-get($neutral, 'neutral-500');
    }

    &-fill {
      * {
        fill: map-get($neutral, 'neutral-500');
      }
    }
  }

  &--allocator {
    * {
      stroke: map-get($secondary, 'blue-500');
    }

    &-fill {
      * {
        fill: map-get($secondary, 'blue-500');
      }
    }
  }

  &--manager {
    * {
      stroke: map-get($user_type, 'manager');
    }

    &-fill {
      * {
        fill: map-get($user_type, 'manager');
      }
    }
  }

  &--serviceprovider {
    * {
      stroke: map-get($user_type, 'service_provider');
    }

    &-fill {
      * {
        fill: map-get($user_type, 'service_provider');
      }
    }
  }

  &--media {
    * {
      stroke: map-get($user_type, 'media');
    }

    &-fill {
      * {
        fill: map-get($user_type, 'media');
      }
    }
  }

  &--guest {
    * {
      stroke: map-get($user_type, 'guest');
    }

    &-fill {
      * {
        fill: map-get($user_type, 'guest');
      }
    }
  }

  &--speaker {
    * {
      stroke: map-get($user_type, 'speaker');
    }

    &-fill {
      * {
        fill: map-get($user_type, 'speaker');
      }
    }
  }

  &--sponsor {
    * {
      stroke: map-get($user_type, 'sponsor');
    }

    &-fill {
      * {
        fill: map-get($user_type, 'sponsor');
      }
    }
  }

  &--iconnections {
    * {
      stroke: map-get($user_type, 'iconnections');
    }

    &-fill {
      * {
        fill: map-get($user_type, 'iconnections');
      }
    }
  }

  &--vendor {
    * {
      stroke: map-get($user_type, 'vendor');
    }

    &-fill {
      * {
        fill: map-get($user_type, 'vendor');
      }
    }
  }

  &--staff {
    * {
      stroke: map-get($user_type, 'staff');
    }

    &-fill {
      * {
        fill: map-get($user_type, 'staff');
      }
    }
  }

  &--typography_black {
    * {
      stroke: map-get($basic, 'black-100');
    }

    &-fill {
      * {
        fill: map-get($basic, 'black-100');
      }
    }
  }

  &--typography_gray {
    * {
      stroke: map-get($grey_scale, 'grey-700');
    }

    &-fill {
      * {
        fill: map-get($grey_scale, 'grey-700');
      }
    }
  }

  &--black {
    * {
      stroke: #000000;
    }

    &-fill {
      * {
        fill: #000000;
      }
    }
  }

  &--white {
    * {
      stroke: #FFFFFF;
    }

    &-fill {
      * {
        fill: #FFFFFF;
      }
    }
  }

  &--gray_800 {
    * {
      stroke: map-get($grey_scale, 'gray-800');
    }

    &-fill {
      * {
        fill: map-get($grey_scale, 'gray-800');
      }
    }
  }

  &--gray_100 {
    * {
      stroke: map-get($grey_scale, 'gray-100');
    }

    &-fill {
      * {
        fill: map-get($grey_scale, 'gray-100');
      }
    }
  }

  &--blue_500 {
    * {
      stroke: map-get($secondary, 'blue-500');
    }

    &-fill {
      * {
        fill: map-get($secondary, 'blue-500');
      }
    }
  }

  &--green_800 {
    * {
      stroke: map-get($success, 'green-800');
    }

    &-fill {
      * {
        fill: map-get($success, 'green-800');
      }
    }
  }

  &--warning {
    * {
      stroke: map-get($warning, 'orange-500');
    }

    &-fill {
      * {
        fill: map-get($warning, 'orange-500');
      }
    }
  }

  &--red_500 {
    * {
      stroke: map-get($error, 'red-500');
    }

    &-fill {
      * {
        fill: map-get($error, 'red-500');
      }
    }
  }

  &--dark_yellow {
    * {
      stroke: #CA952D;
    }

    &-fill {
      * {
        fill: #CA952D;
      }
    }
  }
}
</style>
